import { SlDropdownMenuOption } from '@stackline/ui';
import React from 'react';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import { SlDropdownMenu } from 'src/components/BeaconV2Components/Header/SLDropdownMenu/input';

interface DropdownConfig {
  dropdownOptions: SlDropdownMenuOption[];
  selectedDropdownOption: SlDropdownMenuOption;
  handleDropdownChange: (value: SlDropdownMenuOption) => void;
}

interface BaseDynamicHeaderConfig {
  displayName: string;
}

interface TextDynamicHeaderConfig extends BaseDynamicHeaderConfig {
  displayType: 'text';
}

interface MenuDynamicHeaderConfig extends BaseDynamicHeaderConfig {
  displayType: 'menu';
  dropdownConfig: DropdownConfig;
}

export type DynamicHeaderConfig = TextDynamicHeaderConfig | MenuDynamicHeaderConfig;

interface SlDynamicTableHeaderProps {
  config: DynamicHeaderConfig[];
}

/**
 * Renders a dynamic table header based on the configuration provided.
 * Ex: [Metric dropdown] by [Entity dropdown]
 */
const SlDynamicTableHeader = ({ config }: SlDynamicTableHeaderProps) => {
  return (
    <Flex alignItems="center" gap={6}>
      {config.map((component, index) => {
        switch (component.displayType) {
          case 'text':
            return (
              <Text variant="h4" key={index}>
                {component.displayName}
              </Text>
            );
          case 'menu': {
            const { dropdownConfig } = component;
            return (
              <SlDropdownMenu
                onChange={(e) => dropdownConfig.handleDropdownChange(e)}
                defaultLabel={dropdownConfig.dropdownOptions[0].label}
                selectedId={dropdownConfig.selectedDropdownOption.id}
                buttonVariant="title"
                options={dropdownConfig.dropdownOptions}
              />
            );
          }
          default:
            return null;
        }
      })}
    </Flex>
  );
};

export default SlDynamicTableHeader;
